/* eslint-disable no-undef */
class Nav {
  ToggleDisplayNav($nav) {
    $nav.style.display === 'block'
      ? ($nav.style.display = 'none')
      : ($nav.style.display = 'block')
  }

  ToggleDisplayIconMenu($iconMenu) {
    $iconMenu.style.display === 'none'
      ? ($iconMenu.style.display = 'block')
      : ($iconMenu.style.display = 'none')
  }

  ToggleDisplayIconClose($iconClose) {
    $iconClose.style.display === 'block'
      ? ($iconClose.style.display = 'none')
      : ($iconClose.style.display = 'block')
  }

  ToggleVisibilityHero($hero) {
    $hero.style.visibility === 'visible'
      ? ($hero.style.visibility = 'hidden')
      : $hero.style.visibility === 'hidden'
        ? ($hero.style.visibility = 'visible')
        : null
  }

  handleToggleVisibilityNav(selector) {
    const { $nav, $iconMenu, $iconClose, $hero } = selector

    this.ToggleDisplayNav($nav)
    this.ToggleVisibilityHero($hero)
    this.ToggleDisplayIconMenu($iconMenu)
    this.ToggleDisplayIconClose($iconClose)
  }
}
export default Nav
